import { render, staticRenderFns } from "./EngravingLegalNotice.vue?vue&type=template&id=734da228&scoped=true&"
import script from "./EngravingLegalNotice.vue?vue&type=script&lang=ts&"
export * from "./EngravingLegalNotice.vue?vue&type=script&lang=ts&"
import style0 from "./EngravingLegalNotice.vue?vue&type=style&index=0&id=734da228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734da228",
  null
  
)

export default component.exports